module.exports = __webpack_public_path__ + "img/SL-M-120-170.94c7d204.svg";